import "./index.css";
import React from "react";
import { getCustomerId } from "Common";
import { IS_WHITE_LIST } from "MortgageGPT/constants";

interface TypeRemainingCountProps {
  top: number;
  count: number;
}

/**
 * @name RemainingCount 剩余可用次数
 */
const RemainingCount: React.FC<TypeRemainingCountProps> = ({ count, top }) => {
  // 未登陆不显示剩余次数，会引导注册、等领域
  if (!sessionStorage.getItem("ZeitroA")) {
    return <span />;
  }

  // 不受限制的
  if (["zeitro", "gmcc"].includes(getCustomerId()) || IS_WHITE_LIST) {
    return <span />;
  }

  return (
    <span style={{ paddingTop: top }} className="gpt-remaining-count">
      {count} {count <= 1 ? "query" : "queries"} remaining
    </span>
  );
};

export default RemainingCount;
